
import Utils from '~/assets/utils.js'
import DynamicMarkdown from '~/components/DynamicMarkdown.vue'
import Social from '~/assets/social.js'
import Head from '~/assets/head.js'

export default {
  components: {
    DynamicMarkdown
  },
  mixins: [Head.titleMixin],
  async asyncData ({ $content, params }) {
    const about1 = await $content('about1').fetch()
    const about2 = await $content('about2').fetch()

    return {
      about1,
      about2
    }
  },
  data () {
    return {
      pictures: [
        '/images/about/me_kilt.jpg',
        '/images/about/us_2021_low.jpg'
      ],
      title: 'About Me',
      description: Social.description
    }
  },
  computed: {
    denseTimeline () {
      return this.$vuetify.breakpoint.smAndDown
    }
  },
  methods: {
    // Random color generation from here: http://blog.adamcole.ca/2011/11/simple-javascript-rainbow-color.html
    getRandColor () {
      return Utils.getRandColor()
    },
    getBW (v) {
      v = v * 0.65 + 0.35
      return Utils.bwStop(v)
    },
    prettifyDate (date) {
      return Utils.prettifyDate2(date)
    }
  }
}
